export default __webpack_public_path__ + "e6197588862447c7087cda384d07a5a4.svg";